import _ from 'lodash';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { modal } from '../../modal/ModalEmitter';

import Api from '../../../services/ApiService';

export default class ROInput extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired, // returns valid id or null
    errorText: PropTypes.string.isRequired,
    showErrorText: PropTypes.bool.isRequired, // eslint-disable-line
    updateOpModes: PropTypes.func, // only used by screens that display operation details
    updateMileage: PropTypes.func, // only used by screens that display operation details
  };

  static getDerivedStateFromProps(props) {
    if (props.showErrorText) {
      return {
        showErrorText: true,
      };
    }
    return null;
  }

  state = {
    customerName: null,
    focused: false,
    inputValue: '', // last value entered by user
    showErrorText: false,
    roActive: null, // repair order ONLY IF valid RO found via /api/timeclock/rocustomer
  };

  handleBlur = e => {
    const inputValue = e.target.value.trim();
    let roActive = null;
    let customerName = null;
    let roMileage = null;
    let showErrorText = true;

    if (inputValue) {
      Api.post('timeclock/rocustomer', { ro: inputValue })
        .then(res => {
          if (res.data.trim() === '') {
            throw new Error('Empty Response from RO_CUSTOMER_DATA');
          }
          const details = res.data.split('\n');

          if (!_.includes(['Customer not found', ''], details[0])) {
            roActive = inputValue;
            customerName = details[0].split('ý')[0];
            roMileage = details[0].split('ý')[1];
            showErrorText = false;

            if (this.props.updateMileage) {
              this.props.updateMileage(roMileage);
            }

            if (this.props.updateOpModes) {
              const opModes = [];
              let modesFound = false;

              // Did NASA give us op modes or just a customer name?
              if (details.length > 1) {
                for (let i = 1; i < details.length; i++) {
                  // NASA injects blank lines (why?)
                  if (details[i].trim() !== '') {
                    modesFound = true;
                    const opModeParts = details[i].split('ý');
                    opModes.push({
                      op: opModeParts[0],
                      desc: opModeParts[1] || '',
                    });
                  }
                }
              }

              if (modesFound) {
                this.props.updateOpModes(opModes);
              }
            }

            // Customer not found - clear previously set opModes
          } else {
            if (this.props.updateOpModes) {
              this.props.updateOpModes(null);
            }
          }

          this.props.onChange(roActive || '');
          this.setState({
            customerName,
            focused: false,
            inputValue,
            roActive,
            showErrorText,
          });
        })
        .catch(error => {
          console.error(`Unable to validate RO: ${error}`);
        });
    } else {
      // User has cleared out the field here
      this.props.onChange('');
      this.setState({
        customerName,
        focused: false,
        inputValue,
        roActive,
        showErrorText,
      });
      if (this.props.updateOpModes) {
        this.props.updateOpModes(null);
      }
    }
  };

  handleFocus = () => {
    this.setState({
      focused: true,
      showErrorText: false,
    });
  };

  openAttachments = (roId) => {
    modal.open('attachments', {
      itemId: String(roId).toUpperCase(),
      itemName: 'SMM1',
    });
  };

  render() {
    const style = {};

    if (!!this.state.inputValue && !this.state.focused) {
      // input exists and we're blurred?
      if (this.state.roActive) {
        style.color = 'green';
        this.input.value = `${this.state.roActive}: ${this.state.customerName}`;
      } else {
        style.color = 'red';
        this.input.value = `${this.state.inputValue} - NOT FOUND`;
      }
    } else if (this.input) {
      // empty input or focused
      this.input.value = this.state.inputValue;
    }

    return (
      <div className="tc-roinput-wrapper">
        <input
          autoComplete="off"
          id={this.props.id}
          className="form-control tc-roinput-control"
          onBlur={this.handleBlur}
          onFocus={this.handleFocus}
          ref={input => {
            this.input = input;
          }}
          style={style}
        />
        {this.state.roActive && <Button size="sm" variant="primary" onClick={() => this.openAttachments(this.state.roActive)}>Attachments</Button>}
        {this.state.showErrorText && <div style={{ marginTop: '-15px', color: 'red' }}>{this.props.errorText}</div>}
      </div>
    );
  }
}
